import {useState, useCallback} from '@wordpress/element';
import {PaymentElement} from '@stripe/react-stripe-js';
import {StoreNotice} from '@woocommerce/blocks-checkout';
import {getSetting} from '@woocommerce/settings';
import {getPaymentElementTerms} from '@wc-stripe/blocks-utils';
import {useProcessCheckoutError, useProcessCheckoutSuccess, useCreatePaymentMethod} from "../hooks";

export const CardPaymentElement = (props) => {
    const {data} = props;
    const gatewayId = data.gatewayId;
    const shouldCreatePaymentMethod = !data.installmentsActive;
    const {
        billing: {billingAddress},
        eventRegistration,
        emitResponse,
        shouldSavePayment,
        activePaymentMethod
    } = props;
    const {
        email,
        phone,
        first_name,
        last_name
    } = billingAddress;
    const {
        onCheckoutSuccess,
        onCheckoutFail
    } = eventRegistration;

    const name = data.name;
    const [loadError, setLoadError] = useState(false);

    const {clearPaymentMethodData} = useCreatePaymentMethod({
        name,
        gatewayId,
        emitResponse,
        billingAddress,
        shouldSavePayment,
        eventRegistration,
        activePaymentMethod,
        shouldCreatePaymentMethod
    });

    useProcessCheckoutSuccess({
        name,
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod
    });

    useProcessCheckoutError({
        emitResponse,
        subscriber: onCheckoutFail,
        messageContext: emitResponse.noticeContexts.PAYMENTS,
        clearPaymentMethodData
    });

    const elementOptions = {
        defaultValues: {
            billingDetails: {
                name: `${first_name} ${last_name}`,
                email,
                phone
            }
        },
        fields: {
            billingDetails: {
                address: 'never',
                name: 'never',
                email: 'never',
                phone: !!phone ? 'never' : 'auto'
            }
        },
        wallets: {
            applePay: 'never',
            googlePay: 'never',
            link: data.elementOptions.paymentMethodTypes.includes('link') ? 'auto' : 'never'
        },
        terms: getPaymentElementTerms(data.termsDisplayRule),
        ...data.paymentElementOptions
    }

    const onLoadError = useCallback(response => {
        const {error} = response;
        setLoadError(error);
    }, []);

    if (loadError) {
        const message = getSetting('stripeErrorMessages').payment_unavailable;
        return (
            <StoreNotice
                status={'warning'}
                isDismissible={false}>
                {message.replace('%s', loadError.message)}
            </StoreNotice>
        )
    }

    return (
        <>
            <PaymentElement
                options={elementOptions}
                onLoadError={onLoadError}/>
        </>
    )
}

export default CardPaymentElement;